import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { Setting } from '@core/settings';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { NgClass } from '@angular/common';
import { SearchTriggerComponent } from '@search/ui';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { GenericLinkDirective } from '@core/jss-utils';

import { DrilldownNavComponent } from '../shared/drilldown-nav/drilldown-nav.component';
import { NavigationService } from '../services/navigation.service';
import { TopNavigationComponent } from './top-navigation/top-navigation.component';
import { NavbarComponent } from '../shared/navbar/navbar.component';
import { SearchHeaderComponent } from '../shared/search-header/search-header.component';
import { OffCanvasComponent } from '../shared/off-canvas/off-canvas.component';
import { HeaderToolsContainerComponent } from '../shared/header-tools-container/header-tools-container.component';

@Component({
  selector: 'wl-sticky-header',
  templateUrl: './sticky-header.component.html',
  styleUrls: [
    './sticky-header.component.essent.scss',
    './sticky-header.component.ed.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TopNavigationComponent,
    NavbarComponent,
    SearchHeaderComponent,
    NgClass,
    GenericLinkDirective,
    SearchTriggerComponent,
    OffCanvasComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    DrilldownNavComponent,
    HeaderToolsContainerComponent,
    TrackLinkDirective,
    DeployUrlPipe,
  ],
})
export class StickyHeaderComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isLoggedIn?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() currentNavItems: JssNavItem[] = [];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() originalNavItems: JssNavItem[] = [];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isMainNavigationAvailable?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isTopNavigationAvailable?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() topNavigationItems: JssNavItem[] = [];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() openNavigation?: Setting<LinkField>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isServiceNavigationAvailable?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() serviceNavigationTitle?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() serviceNavigationLink?: Setting<LinkField>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() brandLogoLinkUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrlLabel?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mainNavigationTitle?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showCategories?: boolean;

  @ViewChild(DrilldownNavComponent)
  drillDown?: DrilldownNavComponent;

  isServiceNavigationOpen = false;
  isNavigationOpen = false;

  inSubNavigation = false;

  searchNavigationEnabled = inject(NavigationService).searchNavigationEnabled;
  readonly #searchFeatureEnabled = inject(ENVIRONMENT_CONFIG).search.enabled;

  readonly brand = inject(ENVIRONMENT_CONFIG).brand;

  public selectedItem?: JssNavItem = undefined;

  public searchEnabled() {
    return this.#searchFeatureEnabled;
  }

  public showSearchbar() {
    this.searchNavigationEnabled.set(true);
  }

  public get showMainNavigationTitle(): boolean {
    return (
      this.isServiceNavigationAvailable === true &&
      this.isTopNavigationAvailable === true &&
      this.isMainNavigationAvailable === true
    );
  }

  selectedNavItem(event: { navItem: JssNavItem; depth: number }) {
    if (!event.navItem.children?.length) {
      this.isNavigationOpen = false;
    }

    this.serviceNavigationTitle = event.navItem.name;
    this.inSubNavigation = true;
  }

  previousNavItem() {
    this.serviceNavigationTitle = undefined;
    this.inSubNavigation = false;
    this.drillDown?.pop();
  }

  onOpenChange(isOpened: boolean) {
    if (isOpened) {
      this.drillDown?.reset();
      this.serviceNavigationTitle = undefined;
      this.inSubNavigation = false;
    }
  }
}
